import PropTypes from 'prop-types';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation } from '../../types/ApprovalOperation';
import ApprovalOperationI18n from '../i18n/ApprovalOperationI18n';
import { ApprovalTypes } from '../../types';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalModalFooter(props) {
  const triggerSurvey = () => {
    if (props.showFeedbackSurvey && props.approvalType !== ApprovalTypes.QUOTE && (props.approvalType === ApprovalTypes.DEAL || props.approvalOperation === ApprovalOperation.APPROVE || props.approvalOperation === ApprovalOperation.REQUEST)) {
      props.showFeedbackSurvey();
    }
  };
  if (props.isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsxs(DialogFooter, {
    children: [/*#__PURE__*/_jsx(LoadingButton // Using loading button to prevent user clicking multiple times
    , {
      "data-test-id": `product-approvals-approval-submit-button-${props.approvalOperation}`,
      loading: props.isLoading,
      failed: true // failed is used to not show success icon on finish
      ,
      use: props.buttonUse || 'primary',
      type: "submit",
      disabled: props.disablePrimaryButton,
      onClick: triggerSurvey,
      children: /*#__PURE__*/_jsx(ApprovalOperationI18n, {
        approvalOperation: props.approvalOperation
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      onClick: props.onCancel,
      "data-test-id": "product-approvals-modal-cancel-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.cancel"
      })
    })]
  });
}
ApprovalModalFooter.propTypes = {
  approvalOperation: PropTypes.string.isRequired,
  disablePrimaryButton: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
};
export default ApprovalModalFooter;